

export const USER_DATA: object = {

    trademark: "Clintu",
    legal_name: "Cleaning For You SL",
    cif: "B000000",
    street: "Carrer Marqués de SentMenat",
    number: "54",
    floor: "1",
    door: "1",
    postal_code: "08029",
    city: "Barcelona",
    country: "ES",
    contact_name: "Alex",
    contact_surname: "Espel",
    contact_email: "alex@clintu.es",
    contact_phone: "6000000000"

};

export const USER_OFFICES: Array<object> = [
  {
    trademark: "Clintu",
    legal_name: "Cleaning For You SL",
    cif: "B000000",
    street: "Carrer Marqués de SentMenat",
    number: "54",
    floor: "1",
    door: "1",
    postal_code: "08029",
    products:0,
    city: "Barcelona",
    country: "ES",
    note: "Esto es una nota to flama",
    contacts : [
      {
        name: "Laura",
        surname: "Marin",
        phone: "678 904 677",
        mail: "lauraM@clintu.es"
      }

    ]
  },
  {
    trademark: "Clinta",
    legal_name: "Cleaning For You SL",
    cif: "B000034",
    street: "Carrer Marqués de NoSense",
    number: "54",
    floor: "1",
    door: "1",
    postal_code: "28010",
    products:0,
    city: "Madrid",
    country: "ES",
    note: "Esto es una nota to flama",
    contacts : [
      {
        name: "Luis",
        surname: "Cobo",
        phone: "678 904 677",
        mail: "luis@clintu.es"
      }

    ]
  },

];

export const CLEANER: object = {

    name: "Gessy",
    surname: "Jimena Morales",
    phone: "678904567",
    mail: "gessy_shula@yahoo.com"

}


export const COMMENTS: Array<object> = [

  {
    id:131,
    date:"13/04/2017",
    hour: "12:01",
    person: "Omaita",
    text: "un dos tres pollito inglés a la pared, esto es broza para el comentario to flama."
  },
  {
    id:132,
    date:"13/04/2017",
    hour: "12:36",
    person: "Omaita",
    text: "un dos tres pollito inglés a la pared, esto es broza para el comentario to flama."
  },
  {
    id:133,
    date:"13/04/2017",
    hour: "13:12",
    person: "Pepet",
    text: "un dos tres pollito inglés a la pared, esto es broza para el comentario to flama."
  }

]

export const BILLS: Array<object> = [
  {
    id: 1,
    date: "13/03/17",
    user: "Lisa Carolina Salinas",
    company: "Enzim digital 2015 SL",
    type: "Transf",
    import: 47.80
  },
  {
    date: "13/03/17",
    user: "Willy Wonka",
    company: "Chocolate SL",
    type: "Transf",
    import: 47.80
  },
  {
    id: 2,
    date: "13/03/17",
    user: "Lisa Carolina Salinas",
    company: "Enzim digital 2015 SL",
    type: "Transf",
    import: 47.80
  },
  {
    id: 3,
    date: "13/03/17",
    user: "Lisa Carolina Salinas",
    company: "Enzim digital 2015 SL",
    type: "Transf",
    import: 47.80
  },
  {
    id: 4,
    date: "13/03/17",
    user: "Lisa Carolina Salinas",
    company: "Enzim digital 2015 SL",
    type: "Transf",
    import: 47.80
  },
  {
    id: 5,
    date: "13/03/17",
    user: "Lisa Carolina Salinas",
    company: "Enzim digital 2015 SL",
    type: "Transf",
    import: 47.80
  },
  {
    id: 6,
    date: "13/03/17",
    user: "Lisa Carolina Salinas",
    company: "Enzim digital 2015 SL",
    type: "Transf",
    import: 47.80
  },
  
];

export const STAFF: Array<object> = [
  {
    name: "Alex",
    surname: "Espel",
    email: "alex@clintu.es",
    role: "Administrador"
  },
  {
    name: "Ivan",
    surname: "Peréz",
    email: "ivan@getyourhero.es",
    role: "Administrador"
  },
  {
    name: "Sara",
    surname: "Portillo",
    email: "sara@getyourhero.es",
    role: "Staff"
  },
  {
    name: "Felipe",
    surname: "Fernández",
    email: "felipe@clintu.es",
    role: "Administrador"
  },
];

export const CITIES: Array<object> = [
  { gyh_office: 1, name: "Barcelona"},
  { gyh_office: 1, name: "L'Hospitalet de Llobregat"},
  { gyh_office: 1, name: "Badalona"},
  { gyh_office: 2, name: "Madrid"},
  { gyh_office: 2, name: "Alcorcón"}
]

export const CLEANER_AVAILABILITY: Array<object> = [

    {
    period: "05:00-06:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "06:00-07:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "07:00-08:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "08:00-09:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "09:00-10:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "10:00-11:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "11:00-12:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "12:00-13:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "13:00-14:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "14:00-15:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:true},
      {day:"Saturday",availability:true},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "15:00-16:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "16:00-17:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "17:00-18:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "18:00-19:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "19:00-20:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "20:00-21:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "21:00-22:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "22:00-23:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },
  {
    period: "23:00-00:00",
    days: [
      {day:"Monday",availability:true},
      {day:"Tuesday",availability:true},
      {day:"Wednesday",availability:true},
      {day:"Thursday",availability:true},
      {day:"Friday",availability:false},
      {day:"Saturday",availability:false},
      {day:"Sunday",availability:false}   
    ]
  },


];

export const AVAILABILITY: Array<object> = [

    {
    period: "Ma 23/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },
  {
    period: "Mi 24/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1} 
    ]
  },
  {
    period: "Ju 25/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },
  {
    period: "Vi 26/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },
  {
    period: "Sá 27/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },
  {
    period: "Do 28/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },

  {
    period: "Lu 29/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },
  {
    period: "Ma 30/04",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },
  {
    period: "Mi 01/05",
    hours: [
      {hour:"5:00",availability:true,cleaners: 30},
      {hour:"5:30",availability:true,cleaners: 22},
      {hour:"6:00",availability:true,cleaners: 25},
      {hour:"6:30",availability:true,cleaners: 0},
      {hour:"7:00",availability:true,cleaners: 2},
      {hour:"7:30",availability:true,cleaners: 3},
      {hour:"8:00",availability:false,cleaners: 0},
      {hour:"8:30",availability:true,cleaners: 0},
      {hour:"9:00",availability:true,cleaners: 10},
      {hour:"9:30",availability:true,cleaners: 30},
      {hour:"10:00",availability:true,cleaners: 30},
      {hour:"10:30",availability:true,cleaners: 30},
      {hour:"11:00",availability:true,cleaners: 30},
      {hour:"11:30",availability:false,cleaners: 30},
      {hour:"12:00",availability:true,cleaners: 30},
      {hour:"12:30",availability:true,cleaners: 30},
      {hour:"13:00",availability:true,cleaners: 0},
      {hour:"13:30",availability:true,cleaners: 0},
      {hour:"14:00",availability:false,cleaners: 1},
      {hour:"14:30",availability:true,cleaners: 1},
      {hour:"15:00",availability:true,cleaners: 1},
      {hour:"15:30",availability:true,cleaners: 3},
      {hour:"16:00",availability:true,cleaners: 10},
      {hour:"16:30",availability:false,cleaners: 10},
      {hour:"17:00",availability:true,cleaners: 20},
      {hour:"17:30",availability:true,cleaners: 20},
      {hour:"18:00",availability:true,cleaners: 24},
      {hour:"18:30",availability:true,cleaners: 0},
      {hour:"19:00",availability:false,cleaners: 0},
      {hour:"19:30",availability:true,cleaners: 0},
      {hour:"20:00",availability:true,cleaners: 0},
      {hour:"20:30",availability:true,cleaners: 0},
      {hour:"21:00",availability:true,cleaners: 22},
      {hour:"21:30",availability:false,cleaners: 23},
      {hour:"22:00",availability:true,cleaners: 24},
      {hour:"22:30",availability:true,cleaners: 2},
      {hour:"23:00",availability:true,cleaners: 1}
    ]
  },
  

];


// WEBPACK FOOTER //
// ./src/app/injections/mock-users.ts